<template>
  <div class="backgroud-white cs-courseSchedule-editor">
    <div class="text-center">
      <h4>{{ isAdded?'添加校区': '编辑校区'}}</h4>
    </div>
    <div class="backgroud-gray-popup popup-content-area-small">
      <el-form
        ref="model"
        :rules="rules"
        :model="model"
        label-width="100px"
      >
        <el-form-item
          label="名称"
          prop="name"
        >
          <el-input
            :disabled="!options.basicEditable"
            @change='checkAllInputs'
            placeholder="请输入名称"
            v-model="model.name"
            class="input-width"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="纬度"
          prop="latitude"
        >
          <el-input
            :disabled="!options.basicEditable"
            @change='checkAllInputs'
            placeholder="请输入纬度"
            v-model="model.latitude"
            class="input-width"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="经度"
          prop="longitude"
        >
          <el-input
            :disabled="!options.basicEditable"
            @change='checkAllInputs'
            placeholder="请输入经度"
            v-model="model.longitude"
            class="input-width"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="时区"
          prop="timezone"
        >
          <el-input
            :disabled="!options.basicEditable"
            @change='checkAllInputs'
            placeholder="请输入时区"
            v-model="model.timezone"
            maxlength="50"
            class="input-width"
          ></el-input>
        </el-form-item>
        <el-form-item
          class="cs-courseSchedule-desc"
          label="上课起止时间"
          label-width="100px"
        >
          <label>请添加上课起止时间</label>
        </el-form-item>
        <el-row
          v-for="(schedule,index) in form.schedules"
          :key="index"
        >
          <campus-time-schedule-time-picker
            :rowIndex="index"
            :currentSchedulesAll="form.schedules"
            :scheduleForm="schedule"
            v-on:reduceTime="onReduceTime"
            v-on:editRow="onEditingRow"
            ref="campusTimeScheduleTimePicker"
          >
          </campus-time-schedule-time-picker>
        </el-row>
      </el-form>
    </div>
    <div
      slot="footer"
      class="dialog-footer popup-footer"
    >
      <el-row>
        <el-col
          :span="20"
          class="footer-left"
        >
          <span v-if="!showError"></span>
          <el-alert
            :closable="false"
            v-if="showError"
            v-bind:title="errorMessage"
            type="error"
            show-icon
          ></el-alert>
        </el-col>
        <el-col
          class="footer-right"
          :span="4"
        >
          <el-button
            :disabled="submitBtnDisable"
            :type="submitBtnClass"
            @click="save()"
          >{{ isAdded?'确认添加': '保存更新'}}</el-button>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<style lang="scss" scoped>
</style>

<script>
import campusTimeScheduleTimePicker from "@/components/campusTimeScheduleTimePicker";
import { saveCampus } from "../service/common.service";
import { guid, formatTimeToInt60 } from "../config/mUtils";

export default {
  props: {
    options: {
      basicEditable: Boolean
    },
    dataIn: {}
  },
  data() {
    return {
      model: {
        id: 0,
        name: "",
        longitude: 0,
        latitude: 0,
        timezone: ""
      },
      submitBtnClass: "info",
      submitBtnDisable: true,
      isAdded: false,
      showError: false,
      errorMessage: "",
      form: {
        editingRowId: "",
        schedules: [
          {
            id: guid(),
            dataId: "",
            campusId: "",
            day: "",
            startTime: "",
            endTime: ""
          }
        ]
      },
      rules: {
        name: [
          {
            required: true,
            message: "请输入名称",
            trigger: "blur"
          },
          {
            min: 0,
            max: 200,
            message: "最大长度在为200个字符",
            trigger: "blur"
          }
        ],
        longitude: [
          {
            required: true,
            message: "请输入经度",
            trigger: "blur"
          }
        ],
        latitude: [
          {
            required: true,
            message: "请输入纬度",
            trigger: "blur"
          }
        ],
        timezone: [
          {
            required: false,
            message: "请输入时区",
            trigger: "blur"
          }
        ],
      }
    };
  },
  components: {
    campusTimeScheduleTimePicker
  },
  created() {
    this.init();
    this.loadScheduleData();
  },
  methods: {
    checkAllInputs() {
      let isValid = true;

      if (!this.$refs["model"]) return false;

      this.$refs["model"].validate(valid => {
        if (!valid) {
          isValid = false;
          return;
        }
      });
      return isValid;
    },
    checkAllSchedules() {
      let isValid = true;

      for (let i = 0; i < this.$refs.campusTimeScheduleTimePicker.length; i++) {
        let index = this.$refs.campusTimeScheduleTimePicker.length - 1 - i;
        isValid =
          isValid &&
          this.$refs.campusTimeScheduleTimePicker[index].validateRow();
      }

      return isValid;
    },
    save() {
      let isValid = this.checkAllInputs();
      if (!isValid) return false;
      isValid = this.checkAllSchedules();
      if (!isValid) return false;

      this.submitBtnDisable = true;

      let result = saveCampus(
        this.model.id,
        this.model.name,
        this.model.longitude,
        this.model.latitude,
        this.model.timezone,
        this.form.schedules
      ).then(result => {
        if (!result.success) {
          this.errorMessage = result.message;
          this.showError = true;
        } else {
          this.$message({
            message: "保存成功",
            type: "success"
          });
          this.showError = false;
          this.$emit("saveSuccess", this.isAdded, result.data);
          this.close();
        }
        this.submitBtnDisable = false;
      });
    },
    close() {
      this.$emit("closeDialog");
    },
    init() {
      this.submitBtnClass = "primary";
      this.submitBtnDisable = false;
      if (!!this.dataIn && !!this.dataIn.Id) {
        this.isAdded = false;
        this.model.id = this.dataIn.Id;
        this.model.name = this.dataIn.Name;
        this.model.longitude = this.dataIn.Longitude;
        this.model.latitude = this.dataIn.Latitude;
        this.model.timezone = this.dataIn.Timezone;
      } else {
        this.isAdded = true;
        this.model.id = 0;
        this.model.name = "";
        this.model.longitude = 0;
        this.model.latitude = 0;
        this.model.timezone = "";
      }
    },
    loadScheduleData() {
      if (
        !!this.dataIn &&
        !!this.dataIn.CampusTimeSchedules &&
        this.dataIn.CampusTimeSchedules.length > 0
      ) {
        let list = [];
        this.dataIn.CampusTimeSchedules.forEach(element => {
          let dayofweek = element.DayOfWeek > 0 ? element.DayOfWeek : 7;
          let startTime = formatTimeToInt60(element.StartTimeText);
          let endTime = formatTimeToInt60(element.EndTimeText, true);
          let item = {
            id: guid(),
            dataId: element.Id,
            campusId: element.CampusId,
            day: dayofweek,
            startTime: startTime,
            endTime: endTime
          };
          list.push(item);
        });
        this.$data.form.schedules = list;
      } else {
        this.$data.form.schedules = [
          {
            id: guid(),
            dataId: "",
            campusId: "",
            day: "",
            startTime: "",
            endTime: ""
          }
        ];
      }
    },
    onReduceTime: function(currentRowId, isValid) {},
    onEditingRow(currentRowId) {
      this.form.editingRowId = currentRowId;
    }
    // __findSchedule(rowId) {
    //   var result = null;

    //   for (let i = 0; i < this.form.schedules.length; i++) {
    //     let element = this.form.schedules[i];
    //     if (element.id == rowId) {
    //       result = element;
    //       break;
    //     }
    //   }

    //   return result;
    // }
  },
  watch: {
    dataIn: function() {
      this.init();
      this.loadScheduleData();
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/campusEditor.vue